import { isMobileResolution, isTabletResolution } from "./utils/utils";

const openFrameWindow = (url: string, name: string, w: number = 800, h: number = 600) => {
  if (isMobileResolution() || isTabletResolution()) {
    navigator
      .share({
        title: name,
        url: url,
      })
      .catch((error) => console.log(error));

    return;
  }

  const dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : window.screenX;
  const dualScreenTop = window.screenTop !== undefined ? window.screenTop : window.screenY;

  const width = window.innerWidth
    ? window.innerWidth
    : document.documentElement.clientWidth
      ? document.documentElement.clientWidth
      : screen.width;
  const height = window.innerHeight
    ? window.innerHeight
    : document.documentElement.clientHeight
      ? document.documentElement.clientHeight
      : screen.height;

  const systemZoom = width / window.screen.availWidth;
  const left = (width - w) / 2 / systemZoom + dualScreenLeft;
  const top = (height - h) / 2 / systemZoom + dualScreenTop;

  window.open(
    url,
    name,
    `scrollbars=yes,
      width=${w / systemZoom}, 
      height=${h / systemZoom}, 
      top=${top}, 
      left=${left}`,
  );
};

type SharePoint = "facebook" | "linkedin" | undefined;

export const initShareButtons = () => {
  const shareButtons = document.querySelectorAll<HTMLButtonElement>("[data-share-button]");

  if (shareButtons.length === 0) return;

  const currentURL = encodeURIComponent(window.location.href);

  for (const shareButton of shareButtons) {
    shareButton.addEventListener("click", (event: PointerEvent) => {
      event?.preventDefault();

      const { target } = event;
      const sharePoint = (target as HTMLElement).dataset.shareButton as SharePoint;

      if (!sharePoint) return;

      if (sharePoint === "facebook") {
        openFrameWindow("https://www.facebook.com/sharer/sharer.php?u=" + currentURL, "facebook-share");
      } else {
        openFrameWindow("https://www.linkedin.com/sharing/share-offsite/?url=" + currentURL, "linkedin-share");
      }

      return false;
    });
  }
};
